import { Provider } from 'react-redux';
import store from '../redux/store';
import * as gtag from '../utils/gtag';
import { useRouter } from 'next/dist/client/router';
import { useEffect } from 'react';

import '../styles/normalize.scss';
import '../styles/main.scss';


export default function Resizer({ Component, pageProps }) {
	const router = useRouter();

	useEffect(() => {
		const handleRouteChange = (url: URL) => {
			gtag.pageview(url);
		};
		router.events.on('routeChangeComplete', handleRouteChange);
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};

	}, [router.events]);

	function isNeedShow():boolean {
		if (typeof window !== 'undefined') {
			return [
				'localhost:3000',
				'dev1.retoucher.online',
				'dev2.retoucher.online',
				'staging.retoucher.online',
				'retoucher.online',
				'staging-tools.retoucher.online',
				'tools.retoucher.online'].includes(window.location.host);
        } else {
            return true;
        }
    }

	return (
		<Provider store={store}>
			{isNeedShow() && <Component {...pageProps} />}
		</Provider>
	);
}
